import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { store } from "./store";
import { store_key } from "./symbols";
import element_plus from "@/plugins/element.ui";
import interceptor from "@/plugins/interceptor";

createApp(App)
  .use(element_plus)
  .use(interceptor)
  .use(store, store_key)
  .use(router)
  .mount("#app");
